import { mergeClass } from "../../../utils";
import parse from "html-react-parser";
import {
  Border,
  DivWFHF,
  IPreviewProps,
  WaveImage,
  getTextSlideData,
} from "./utils";
import { ImageWithLoading } from "../../../components/ImageWithLoading";

const DG1ImageTemplate = ({ itemData }: IPreviewProps) => {
  const { bgColor } = getTextSlideData(itemData);
  return (
    <DivWFHF className="flex" style={{ backgroundColor: bgColor }}>
      {itemData && (itemData.videoThumbnail || itemData.imageUrl) ? (
        <img
          className="w-full h-full object-cover"
          src={itemData.videoThumbnail || itemData.imageUrl}
        />
      ) : (
        <div className="w-full text-center place-self-center text-darkGrayBg">
          Upload image / video for preview
        </div>
      )}
    </DivWFHF>
  );
};

const DG1TextTemplate = ({ itemData }: IPreviewProps) => {
  const { bgColor, pictogram, darkBg } = getTextSlideData(itemData);
  return (
    <DivWFHF
      className={mergeClass("grid grid-cols-4 content-center", {
        "text-white": darkBg,
      })}
      style={{ backgroundColor: bgColor }}
    >
      <DivWFHF
        className={mergeClass("overflow-hidden grid col-span-3 font-bold", {
          // "col-span-3": itemData.pictogram !== "None",
          // "col-span-4": itemData.pictogram === "None",
        })}
      >
        <div
          className={
            "w-[84%] text-[1.37rem] leading-[1.2] tracking-[0.03rem] place-self-center"
          }
        >
          {itemData.message || (
            <span className="font-thin text-lg text-darkGrayBg">
              Enter a message
            </span>
          )}
        </div>
      </DivWFHF>
      <div className="place-self-center">
        {pictogram && (
          <img
            src={`/assets/pictograms/${pictogram}`}
            className={mergeClass("w-[5.1rem] h-[5.1rem] filter", {
              "brightness-0": !darkBg,
            })}
          />
        )}
      </div>
    </DivWFHF>
  );
};

const DG1TextAndImageTemplate = ({
  itemData,
  reverse,
}: IPreviewProps & { reverse: boolean }) => {
  const { bgColor, hasTitle, darkBg } = getTextSlideData(itemData);
  return (
    <div
      className="w-full h-full grid grid-cols-2 -z-10"
      style={{ backgroundColor: bgColor }}
    >
      <DivWFHF
        className={mergeClass("grid grid-cols-2", {
          "text-white": darkBg,
        })}
      >
        {hasTitle && (
          <DivWFHF
            className={mergeClass(
              "grid content-center px-7 overflow-hidden font-bold relative",
              "text-[1.12rem] leading-[1.1rem] tracking-[0.045rem]"
            )}
          >
            <WaveImage darkBg={darkBg} className="w-12 top-[10px]" />
            {itemData.title}
          </DivWFHF>
        )}
        <DivWFHF
          className={mergeClass("relative text overflow-hidden", {
            "col-span-2 grid content-center": !hasTitle,
            "grid content-center": hasTitle,
          })}
        >
          {!hasTitle && (
            <WaveImage darkBg={darkBg} className="w-12 top-[10px]" />
          )}
          <div className="pl-[1.8rem] pr-[1.25rem] text-[0.68rem] leading-[1.379] place-self-center">
            {itemData.caption && itemData.caption.length > 0 ? (
              parse(itemData.caption)
            ) : (
              <span className="font-thin text-lg text-darkGrayBg">
                Add a caption
              </span>
            )}
          </div>
        </DivWFHF>
      </DivWFHF>
      <div
        className={mergeClass("h-full overflow-hidden", {
          "order-first": reverse,
        })}
      >
        {itemData && (itemData.videoThumbnail || itemData.imageUrl) ? (
          <ImageWithLoading
            className="w-full h-full object-cover"
            src={itemData.videoThumbnail || itemData.imageUrl}
          />
        ) : (
          <div className="grid h-full content-center text-center text-darkGrayBg col-span-2 bg-white/30">
            Upload image / video for preview
          </div>
        )}
      </div>
    </div>
  );
};

const DG1TextAndImageForward = (props: IPreviewProps) => (
  <DG1TextAndImageTemplate {...props} reverse={false} />
);

const DG1TextAndImageReverse = (props: IPreviewProps) => (
  <DG1TextAndImageTemplate {...props} reverse={true} />
);

const DG1Previews = [
  DG1ImageTemplate,
  DG1ImageTemplate,
  DG1TextTemplate,
  DG1TextAndImageForward,
  DG1TextAndImageReverse,
  DG1TextAndImageForward,
  DG1TextAndImageReverse,
];

const PreviewDG1 = ({ itemData }: IPreviewProps): JSX.Element => {
  const Preview = DG1Previews[itemData.templateType] || null;
  return (
    <div className="relative w-[704px] h-[99px]">
      {Preview ? (
        <div className="-z-[10] h-full w-full text-left">
          <Preview itemData={itemData} />
        </div>
      ) : (
        <DivWFHF className="text-center grid content-center text-darkGrayBg">
          Preview unavailable
        </DivWFHF>
      )}
      <div className="absolute top-0 left-0 w-full h-full grid grid-cols-4">
        <Border />
        <Border />
        <Border />
        <Border />
      </div>
    </div>
  );
};

export default PreviewDG1;
